import commonApi from "../../services/CommonApi";
import router from "../../router";

export default {
  state: {
    loggedInUser:
      localStorage.getItem("userInfo") != null
        ? localStorage.getItem("userInfo")
        : null,
  },
  getters: {
    loggedInUser: state => state.loggedInUser,
  },
  mutations: {
    setUser(state, data) {
      state.loggedInUser = data;
    },
    setLogout(state) {
      state.loggedInUser = null;
      // router.go("/app/sessions/signIn");
      router.push('/login');
    },
    setLogout_2(state) {
      state.loggedInUser = null;
      // router.go("/app/sessions/signIn");
    },
  },
  actions: {
    login({ commit }, data) {

      commonApi.post_data('sahaj.finalapi.app_login', data)
        .then(r => {
          if (r.key_details) {
            var userJson = {
              "username": r.full_name,
              ...r.key_details
            };
            localStorage.setItem("userInfo", JSON.stringify(userJson));
            commit("setUser", { uid: r.user });
            router.push("/doctor/index");
          } else {
            console.log(r);
          }
        })
        .catch(function (error) {
          console.log(error);
          localStorage.removeItem("userInfo");
        });
    },
    signUserUp({ commit }, data) {
      
      
    },
    signOut({ commit }) {
      localStorage.removeItem("userInfo");
      commit("setLogout");
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/authData.js